import { MenuItem } from '@src/common/components/Menu';
import { useToast } from '@src/common/hooks/useToast';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { OrderActions } from '@src/orders/domain/OrderList';
import { useForceToReview } from '@src/orders/hooks/useForceToReview';
import { useTranslation } from 'react-i18next';

type Props = {
  order: OrderListing;
  onStatusChange: () => void;
};

export const ForceToReviewAction = ({ order, onStatusChange }: Props) => {
  const { t } = useTranslation();
  const { showSuccessToast, showErrorToast } = useToast();

  const { forceToReview } = useForceToReview({
    onSuccess: () => {
      showSuccessToast(t('orderSummary.forceToReview.success'));
      onStatusChange();
    },
    onError: () => {
      showErrorToast(t('orderSummary.forceToReview.error'));
    },
  });

  const handleForceToReview = () => {
    forceToReview({ orderId: order.id });
  };

  return (
    order.canDo(OrderActions.FORCE_TO_REVIEW) && (
      <MenuItem
        key={`${order.id}-force-to-review`}
        onClick={handleForceToReview}
      >
        {t('forceToReview')}
      </MenuItem>
    )
  );
};
